import router from '@/router';
import { haveProperty } from '@/utils/';
/**
 *
 * Criação do objecto de importar contactos.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * preenchidos na página é que serão enviados. Assim irá permitir usar esta função
 * na adição e na edição deste modelo.
 *
 * @param {Object}  data
 * @param {Object}  helpers
 *
*/
const create = data => {
    const route = router.currentRoute;
    // construção da estrutura das respostas
    // para ser enviado para API.
    const importContacts = {
        campaign_id: route.params.id,
        _method: 'post',
        type: haveProperty( data, 'resources' ) ? 'file' : 'entities',
        ...( haveProperty( data, 'entitiesIds' ) && { data: [] }),
        ...( haveProperty( data, 'resources' ) && { file: data.resources[0] })
    };

    if ( haveProperty( data, 'entitiesIds' ) ) {
        data.entitiesIds.forEach( ( element, index ) => {
            importContacts[`data[${index}]`] = element;
        });
    }

    return importContacts;
};

const requiredFields = [ { field: 'resources', isRequiredOnEdit: false } ];

export {
    create,
    requiredFields
};